import {useParams} from "react-router-dom";
import {useState} from "react";
import {UserDetailListWrapper} from "../../../../styles/main/user";
import FilterLayout from "../../../layout/filter/FilterLayout";
import {useGetOtcOrders} from "../../../../core/services/react-query/report/orders";
import {CacheKeys, otcTradeFilterOptions} from "../../../../core/constants/filter";
import OtcTrades from "../../reports/all-orders/otc/OtcTrades";
import {useAclContext} from "../../../../core/contexts/acl";


const UserOtcTrades = () => {

    const params = useParams()
    const [trades, setTrades] = useState({loading: true, data: null})
    const { permissions } = useAclContext()
    const hasDownload = permissions?.export?.write
    const onQuerySuccess = (res) => {
        setTrades(res)
    }

    return (
        <UserDetailListWrapper>
            <FilterLayout
                query={useGetOtcOrders}
                options={otcTradeFilterOptions}
                onQuerySuccess={onQuerySuccess}
                cache={CacheKeys.USER_OTC}
                extra={{ 'client.userId': params.id }}
                hasDownload={hasDownload}
            >
                <OtcTrades
                    data={trades}
                />
            </FilterLayout>
        </UserDetailListWrapper>
    )
}

export default UserOtcTrades
